import { useEffect, useRef, useState } from "react";

import artwork from "../../../assets/img/onboardingImg/background-artwork.png";
import AddOrganization from "./StepComponents/AddOrganization";
import AddProject from "./StepComponents/AddProject";
import InviteMembers from "./StepComponents/InviteMembers";
import PreviousButton from "./StepComponents/PreviousButton";
import PricingPlan from "./StepComponents/PricingPlan/PricingPlan";
import SelectPlan from "./StepComponents/SelectPlan";
import {
  OnboardingArtwork,
  OnboardingArtworkDiv,
  OnboardingStepsContainer,
  PricingPlanContainer,
} from "./onboardingStepsStyles";

const OnboardingSteps = props => {
  const [organizationData, setOrganizationData] = useState(null);
  const [activateFormAlert, setActivateFormAlert] = useState(false);
  const [invitationsData, setInvitationsData] = useState(null);
  const [planData, setPlanData] = useState(null);
  const [activeStep, setActiveStep] = useState("organization");
  const [hideArtwork, setHideArtwork] = useState(false);
  const [showInviteSection, setShowInviteSection] = useState(false);

  const [eliteYearly, setEliteYearly] = useState({
    id: "",
    paddleId: null,
  });

  const [standardYearly, setStandardYearly] = useState({
    id: "",
    paddleId: null,
  });

  // refs
  const organizationRef = useRef(null);
  const pricingRef = useRef(null);
  const inviteMembersRef = useRef(null);

  const { subscriptionPlans } = props;

  useEffect(() => {
    props.getOrganizationPlans();
  }, []);

  useEffect(() => {
    if (subscriptionPlans && subscriptionPlans.length > 0) {
      subscriptionPlans.forEach(plan => {
        if (plan.nick_name === "elite-yearly") {
          setEliteYearly(plan);
        }
        if (plan.nick_name === "standard-yearly") {
          setStandardYearly(plan);
        }
      });
    }
  }, [subscriptionPlans]);

  useEffect(() => {
    if (props.redirect) {
      props.history.push("/setup/onboarding-loader");
    }
  }, [props.redirect]);

  // useEffect(() => {
  //   if (planData && planData.id) {
  //     if (planData.name !== "Solo") {
  //       setShowInviteSection(true);
  //     } else if (planData.name === "Solo") {
  //       setShowInviteSection(false);
  //       handleSubmitDataFromPlan(planData.id);
  //     }
  //     let orgData = { ...organizationData };
  //     orgData.plan_id = planData.id;
  //     setOrganizationData(orgData);
  //   }
  // }, [planData]);

  // const onScroll = () => {
  //   if (pricingRef && pricingRef.current) {
  //     if (
  //       window.scrollY > pricingRef.current.offsetTop - 600 &&
  //       window.scrollY <
  //       pricingRef.current.offsetTop + pricingRef.current.clientHeight &&
  //       hideArtwork === false
  //     ) {
  //       setHideArtwork(true);
  //     } else {
  //       setHideArtwork(false);
  //     }
  //   }
  // };

  const handleBack = step => {
    let offsetPosition;
    if (step === "organization") {
      props.history.push("/setup/add-or-join");
    } else if (step === "invite-member") {
      if (organizationRef && organizationRef.current) {
        offsetPosition = organizationRef.current.offsetTop - 70;
      }
      setActiveStep("organization");
    }
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  const handleNext = step => {
    let offsetPosition;
    if (step === "organization") {
      if (pricingRef && pricingRef.current) {
        offsetPosition = pricingRef.current.offsetTop - 100;
        setActiveStep("pricing");
      }
    } else if (step === "invite-member") {
      if (pricingRef && pricingRef.current) {
        offsetPosition = pricingRef.current.offsetTop - 200;
        setActiveStep("pricing");
      }
    }
    if (!offsetPosition) return;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  const handleSubmitData = planId => {
    if (
      !organizationData ||
      !organizationData.name ||
      !organizationData.timezone
    ) {
      setActivateFormAlert(true);
    }
    if (organizationData && organizationData.name && planId) {
      const organization = { ...organizationData };
      organization.plan_id = planId;
      const payload = {
        organization,
        invitations: invitationsData ? invitationsData : null,
      };
      props.saveOnboardingData(payload);
    }
  };

  return (
    <div>
      <OnboardingStepsContainer>
        <AddOrganization
          ref={organizationRef}
          activeStep={activeStep}
          handleBack={handleBack}
          handleNext={handleNext}
          organizationData={organizationData}
          setOrganizationData={setOrganizationData}
          activateFormAlert={activateFormAlert}
        />
        {showInviteSection && (
          <InviteMembers
            ref={inviteMembersRef}
            activeStep={activeStep}
            handleBack={handleBack}
            handleNext={handleNext}
            organization={organizationData}
            setInvitationsData={setInvitationsData}
          />
        )}

        <PricingPlanContainer ref={pricingRef}>
          <SelectPlan
            eliteYearly={eliteYearly}
            standardYearly={standardYearly}
            handleSubmitData={handleSubmitData}
            onboardingIsLoading={props.isLoading}
          />
        </PricingPlanContainer>
      </OnboardingStepsContainer>
      <OnboardingArtworkDiv hide={hideArtwork}>
        <OnboardingArtwork hide={hideArtwork} src={artwork} alt="" />
      </OnboardingArtworkDiv>
    </div>
  );
};

export default OnboardingSteps;
